module.exports = __webpack_public_path__ + "static/img/Snake.c82e962.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Snake.svg
// module id = 1368
// module chunks = 0